import { ViewerTool, type FeatureFlag } from "@/store/features/features";
import { FaroText, FeatureTourPage } from "@faro-lotv/flat-ui";
import { Link } from "@mui/material";
import DraftViewAnnouncementImage from "../../data-preparation-tool/icons/draft-view-announcement.png";

/**
 * All the possible keys for feature tour topics to show in the Viewer.
 * The values are used to remember which feature tours the user has seen.
 *
 * IMPORTANT:
 * The values must remain the same across versions to avoid duplicate feature tours.
 */
export enum FeatureTourViewerTopic {
  /** Introducing the Draft view to the user. */
  draftView = "viewer:draft-view",
}

export type FeatureTourTopic = {
  /** The unique identifier of the topic, to remember the current status. */
  topicId: FeatureTourViewerTopic;

  /** On which tools the feature tour should be shown. */
  tools: ViewerTool[];

  /** Only show the topic if the given feature flags are enabled. */
  featureFlags?: FeatureFlag[];

  /** The content to show in the feature tour. */
  pages: FeatureTourPage[];
};

/**
 * The list of all feature tour topics to show in the Viewer.
 *
 * IMPORTANT:
 * The order of the array matters!
 * It determines in which order the feature tours are shown to the user.
 */
export const featureTourTopics: FeatureTourTopic[] = [
  {
    topicId: FeatureTourViewerTopic.draftView,
    tools: [ViewerTool.dataPreparationTool],
    pages: [
      {
        title: "Welcome to Draft view",
        description: (
          <>
            Prepare your data before it goes live.
            <ul>
              <li>Import and manage scan data</li>
              <li>Inspect, edit and refine registrations</li>
              <li>Publish your changes when you're ready</li>
            </ul>
            <Link
              href="https://help.holobuilder.com/en/articles/10696036-inspect-your-project-in-the-draft-view"
              target="_blank"
            >
              <FaroText variant="hyperLink">Learn more</FaroText>
            </Link>
          </>
        ),
        image: {
          src: DraftViewAnnouncementImage,
          altText: "Draft view",
        },
      },
    ],
  },
];
